class User {
    constructor({
        user_id,
        realname,
        user_email,
        birthday,
        m_phone,
        post_code,
        user_address,
        user_address_etc,
        children = [],
        m_phone1,
        m_phone2,
        m_phone3
    }) {
        this.user_id = user_id;
        this.realname = realname;
        this.user_email = user_email;
        this.birthday = birthday;
        this.m_phone = m_phone;
        this.post_code = post_code;
        this.user_address = user_address;
        this.user_address_etc = user_address_etc;
        this.children = children;
    }

    setUserId(id) {
        this.user_id = id;
    }

    setRealname(name) {
        this.realname = name;
    }

    setBirthday(date = "1900-01-01") {
        this.birthday = date;
    }

    setChildren(children = []) {
        this.children = children;
    }

    setPhone(m_phone) {
        this.m_phone = m_phone;
    }

    setPostCode(post_code) {
        this.post_code = post_code;
    }

    setUserAddress(user_address) {
        this.user_address = user_address;
    }

    setUserAddressEtc(user_address_etc) { 
        this.user_address_etc = user_address_etc;
    }

    setEmail(user_email) {
        this.user_email = user_email;
    }
}

export default User;



// WEBPACK FOOTER //
// ./js/waglebagle/Object/user.js